var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEditorCrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 16.4557H8.25008C4.64175 16.4557 3.54175 15.3557 3.54175 11.7474V4.16406C3.54175 3.8224 3.82508 3.53906 4.16675 3.53906H11.7501C15.3584 3.53906 16.4584 4.63906 16.4584 8.2474V15.8307C16.4584 16.1724 16.1751 16.4557 15.8334 16.4557ZM4.79175 4.78906V11.7474C4.79175 14.6557 5.34175 15.2057 8.25008 15.2057H15.2084V8.2474C15.2084 5.33906 14.6584 4.78906 11.7501 4.78906H4.79175Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 4.78906C3.82508 4.78906 3.54175 4.50573 3.54175 4.16406V1.66406C3.54175 1.3224 3.82508 1.03906 4.16675 1.03906C4.50841 1.03906 4.79175 1.3224 4.79175 1.66406V4.16406C4.79175 4.50573 4.50841 4.78906 4.16675 4.78906Z",
    fill: "#FB4764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 4.78906H1.66675C1.32508 4.78906 1.04175 4.50573 1.04175 4.16406C1.04175 3.8224 1.32508 3.53906 1.66675 3.53906H4.16675C4.50841 3.53906 4.79175 3.8224 4.79175 4.16406C4.79175 4.50573 4.50841 4.78906 4.16675 4.78906Z",
    fill: "#FB4764"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 18.9609C15.4916 18.9609 15.2083 18.6776 15.2083 18.3359V15.8359C15.2083 15.4943 15.4916 15.2109 15.8333 15.2109C16.1749 15.2109 16.4583 15.4943 16.4583 15.8359V18.3359C16.4583 18.6776 16.1749 18.9609 15.8333 18.9609Z",
    fill: "#FB4764"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 16.4609H15.8333C15.4916 16.4609 15.2083 16.1776 15.2083 15.8359C15.2083 15.4943 15.4916 15.2109 15.8333 15.2109H18.3333C18.6749 15.2109 18.9583 15.4943 18.9583 15.8359C18.9583 16.1776 18.6749 16.4609 18.3333 16.4609Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEditorCrop);
export default __webpack_public_path__ + "static/media/ImageEditorCrop.848f727f3074dee86607841fbb55ac09.svg";
export { ForwardRef as ReactComponent };